import React from "react";
import { TextField, 
  OutlinedInput, 
  InputLabel, 
  FormControl, 
  InputAdornment, 
  IconButton, Button } from "@mui/material";

import { useState } from "react";
import CheckBoxCustom from "../checkbox";

const SignIn = ({closeDialog, forgotPass}) => {

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [remember, setRemember] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = () => {
    closeDialog()
  }

  return (
    <>
      <div className="account-content px-4 px-sm-6">
        <TextField 
          className="mb-3 w-100" 
          label="Нэвтрэх нэр" 
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <FormControl className="w-100 mb-3" variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Нууц үг</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <i className='bx bx-show font-size-16'></i> : <i className='bx bx-low-vision font-size-16'></i>}
                </IconButton>
              </InputAdornment>
            }
            label="Нууц үг"
          />
        </FormControl>
        <div className="d-flex justify-content-between align-items-center font-size-14">
          <div className={`d-flex align-items-center ${remember ? 'text-black' : 'text-grey'}`}>
            <CheckBoxCustom 
              value={remember}
              handleChange={(e) => setRemember(e.target.checked)}
            />
            Нэвтрэх нэр санах
          </div>
          <div className="pointer" onClick={() => forgotPass()}>
            Нууц үг сэргээх
          </div>
        </div>
      </div>
      <div className="dialog-footer">
        <Button
          onClick={onSubmit}
          className="bg-primary btn-bordered w-100"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Нэвтрэх</span>
        </Button>
      </div>
    </>
  )
}

export default SignIn;
